"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = createClient;
var _routing = require("../../routing.cjs");
var _index = require("../../types/index.cjs");
function createClient(api) {
  async function list() {
    const url = _routing.routing.coverageIntegrationsUrl;
    const {
      integrations
    } = await api.get(url);
    return integrations;
  }
  async function get(integrationId) {
    const url = _routing.routing.coverageIntegrationsUrl;
    const {
      integration
    } = await api.get(`${url}/${integrationId}`);
    return integration;
  }
  async function create(payload) {
    const url = _routing.routing.coverageIntegrationsUrl;
    const {
      integration
    } = await api.post(url, {
      payload
    });
    return integration;
  }
  async function update(integrationId, payload) {
    const url = _routing.routing.coverageIntegrationsUrl;
    const {
      integration
    } = await api.patch(`${url}/${integrationId}`, {
      payload
    });
    return integration;
  }
  async function activate(integrationId) {
    const url = _routing.routing.coverageIntegrationsUrl;
    const {
      integration
    } = await api.post(`${url}/${integrationId}/activate`);
    return integration;
  }
  async function trigger(integrationId) {
    const url = _routing.routing.coverageIntegrationsUrl;
    return api.post(`${url}/${integrationId}/trigger`);
  }
  async function doDelete(integrationId) {
    const url = _routing.routing.coverageIntegrationsUrl;
    return api.delete(`${url}/${integrationId}`);
  }
  async function listRuns(integrationId, options = {}) {
    const {
      sortOrder,
      limit,
      offset
    } = options;
    const url = _routing.routing.coverageIntegrationsUrl;
    return api.get(`${url}/${integrationId}/runs`, {
      query: {
        sort: _index.SortOrder.stringify(sortOrder),
        limit,
        offset
      }
    });
  }
  async function preview(provider, options) {
    const {
      input,
      oldest,
      limit
    } = options;
    return api.post(`${_routing.routing.coverageIntegrationsUrl}/preview`, {
      payload: {
        provider,
        input,
        oldest,
        limit
      }
    });
  }
  return {
    list,
    get,
    create,
    update,
    activate,
    trigger,
    delete: doDelete,
    listRuns,
    preview
  };
}